const generalProductInformationDescriptor = Object.freeze({
    type: 'general-product-information',
    version: 1,
    defaultTitleKey: 'Page(ReceivedRequest):Component(StepItem):general-product-information-label',
    fallbackTitle: 'General product information',
    capabilities: {
        repeatable: false,
        supportedModes: ['single'],
        supportsReadOnly: true,
        contributesToReply: true,
    },
    dataScopes: {
        reads: [
            'request.details',
            'product.card',
        ],
        writes: [
            'product.card',
        ],
    },
    effects: {
        publishes: [
            'product.card.changed',
        ],
        observes: [],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            showMaterialMixtureCategorySelector: {
                type: 'boolean',
                default: true,
            },
        },
    },
    settingsUi: {
        showMaterialMixtureCategorySelector: {
            control: 'switch',
            labelKey: 'Component(ProductMaterialMixtureCategorySelector):categories',
        },
    },
})

export { generalProductInformationDescriptor }
export default generalProductInformationDescriptor
